import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CommonService } from '../../common-service';
import { environment } from '../../../../../environments/environment';
import { ListaEmpresaAdminResponse } from '../../responses/usuario/lista-empresa-admin.response';

@Injectable({
  providedIn: 'root',
})
export class ListaEmpresaAdminService extends CommonService {
  constructor(
    private router: Router,
    private httpClient: HttpClient
  ) {
    super();
  }

  public get(textoBusca: string | null = null): Observable<ListaEmpresaAdminResponse> {
    let uri: string = `ListaEmpresaAdmin?`;

    if (textoBusca) {
      uri += `textoBusca=${textoBusca}`;
    }

    return this.httpClient
      .get<ListaEmpresaAdminResponse>(environment.urlApiUsuario + uri, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public post(listaIDEmpresa: number[]): Observable<ListaEmpresaAdminResponse> {
    return this.httpClient
      .post<ListaEmpresaAdminResponse>(
        environment.urlApiUsuario + `ListaEmpresaAdmin/`,
        listaIDEmpresa,
        this.addHeaderToken()
      )
      .pipe(catchError(this.handleError));
  }
}
